import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { Modal } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import limpiarHtml from '../Compartido/limpiarHtml.js';
import { avisarExtrasNuevos, claveExtra, salidaFilasExtras } from "../Compartido/avisoExtras";

const DatosReserva = ({ propiedad, precios, llegada, salida, difdias, adultos, ninos, bebes, lang, ruta, config, tpvs, paypal, transferencia, stripe, paycomet, moneda, numpropiedades, websgrupo, tarifa, paises }) => {

    let { t } = useTranslation();

    let token = document.getElementById("meta_token").getAttribute("content");

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    let resprices = [];
    let resextras = [];

    let precioBase = 0;
    let cuentaNoches = 0;
    let sumaextras = 0;

    let prepago = 0;

    const [detallesAbiertos, setDetallesAbiertos] = useState(false);
    const [modalPolitica, setModalPolitica] = useState(null);

    // llegada/salida arriben com "YYYY-MM-DD" — es mostren DD/MM/YYYY,
    // mateix format que ReservaHotel i Buscar2.
    const formatoFechaLlarga = (data) => {
        if (!data) return "";
        const parts = data.split("-");
        return parts.length === 3 ? parts[2] + "/" + parts[1] + "/" + parts[0] : data;
    };

    // Extres triats dins "Detalles" de la targeta. El contenidor no té fills
    // de React: s'omple directament al DOM perquè un re-render no reescrigui
    // els imports dels inputs ocults que el càlcul acaba d'escriure.
    const extrasPrevRef = useRef(null);

    const pintarExtrasResumen = () => {
        const elegidos = [...document.querySelectorAll("select.extra[data-extraid]")].filter(sel => sel.value === "1");
        const nuevos = avisarExtrasNuevos(elegidos, extrasPrevRef);
        document.querySelectorAll("[data-extras-hab]").forEach((cont) => {
            const selects = elegidos;
            const viejas = [...cont.querySelectorAll(".bh-cart__extra[data-clave]")];
            cont.innerHTML = "";
            if (selects.length === 0) {
                cont.textContent = "—";
                salidaFilasExtras(cont, viejas);
                return;
            }
            selects.forEach((sel) => {
                let precio = parseFloat(sel.getAttribute("data-precio")) / 100;
                if (parseInt(sel.getAttribute("data-porpersona"))) precio *= parseInt(sel.getAttribute("data-numpersonas"));
                if (parseInt(sel.getAttribute("data-pordia"))) precio *= parseInt(sel.getAttribute("data-numdias"));
                if (parseInt(sel.getAttribute("data-pormes"))) precio *= parseInt(sel.getAttribute("data-numdias")) / 30;
                const fila = document.createElement("div");
                fila.className = "bh-cart__extra" + (nuevos.has(claveExtra(sel)) ? " bh-cart__extra--nuevo" : "");
                const nom = document.createElement("span");
                nom.textContent = sel.getAttribute("data-nombre");
                const preu = document.createElement("strong");
                preu.textContent = roundN(precio, 2) + " " + moneda;
                fila.appendChild(nom);
                fila.appendChild(preu);
                fila.setAttribute("data-clave", claveExtra(sel));
                cont.appendChild(fila);
            });
            salidaFilasExtras(cont, viejas);
        });
    };

    useEffect(() => {
        pintarExtrasResumen();
    }, [detallesAbiertos]);

    let vectornumpropiedades = []

    for (let i = 0; i < numpropiedades; i++) {
        if (i === 0)
            vectornumpropiedades = vectornumpropiedades.concat(<option value={i + 1} key={"vp" + i} data-key={"vp" + i}>{(i + 1) + " " + t("habitación")} </option>)
        else
            vectornumpropiedades = vectornumpropiedades.concat(<option value={i + 1} key={"vp" + i} data-key={"vp" + i}>{(i + 1) + " " + t("habitaciones")} </option>)
    }

    const [mostrarExtras, setMostrarExtras] = useState(propiedad.relacion_extras.length == 0 ? 'none' : "block");

    const [mostrarTarifas, setMostrarTarifas] = useState(mostrarExtras == "block" ? "none" : (tarifa || precios.length == 1) ? "none" : "block");

    const [mostrarDescuento, setMostrarDescuento] = useState(mostrarTarifas == "block" ? "none" : mostrarExtras == "block" ? "none" : "block");

    const [mostrarDadesClient, setMostrarDadesClient] = useState("none");

    const [mostrarInfoPago, setMostrarInfoPago] = useState("none");

    const [mostrarInfoTarjeta, setMostrarInfoTarjeta] = useState("none");

    const [mostrarPagar, setMostrarPagar] = useState("none");

    const toggleTarifas = (e) => {
        e.stopPropagation();
        setMostrarTarifas("block");
        setMostrarExtras("none");

    };

    const toggleExtresTarifas = (e) => {
        e.stopPropagation();
        setMostrarExtras("block");
        setMostrarTarifas("none");
        setMostrarDescuento("none");
    };

    const toggleTarifasDescuento = (e) => {
        e.stopPropagation();
        setMostrarExtras("none");
        setMostrarDescuento("block");
        setMostrarTarifas("none");
    };

    const toggleDescuentoTarifas = (e) => {
        e.stopPropagation();
        setMostrarDescuento("none");
        setMostrarTarifas("block");
    };

    const toggleDescuentoDadesClient = (e) => {
        e.stopPropagation();
        setMostrarDescuento("none");
        setMostrarDadesClient("block");
    };

    const toggleDadesClientDescuento = (e) => {
        e.stopPropagation();
        setMostrarDescuento("block");
        setMostrarDadesClient("none");
    };

    const toggleDadesClientInfoPago = (e) => {
        e.stopPropagation();
        setMostrarDadesClient("none");
        setMostrarInfoPago("block");
        setMostrarPagar("block");
    };

    const toggleDadesInfoPagoClient = (e) => {
        e.stopPropagation();
        setMostrarDadesClient("block");
        setMostrarInfoPago("none");
        setMostrarPagar("none");
    };

    {/* *************** */ }

    const [idTarifaRef, setIdTarifaRef] = useState(precios[0].id);
    const [idPoliticaRef, setIdPoliticaRef] = useState(precios[0].info_tarifa.politica.id);
    const [priceRef, setPriceRef] = useState(null);
    const [prepagoRef, setPrepagoRef] = useState(precios[0].info_tarifa.politica.prepago);
    const [cantApartRef, setCantApartRef] = useState(1);
    const sumaExtrasRef = useRef(0);
    const sumaExtras2Ref = useRef(0);
    const feesRef = useRef(0);
    const pextraRef = useRef(null);
    const pextranombresRef = useRef(null);
    const preciosDiariosRef = useRef(null);

    const losextrasRef = useRef(null);

    const nombrecRef = useRef(null);
    const apellidoscRef = useRef(null);
    const emailcRef = useRef(null);
    const telefonocRef = useRef(null);
    const documentocRef = useRef(null);
    const aceptacondicionesRef = useRef(null);
    const phoneDropdownRef = useRef(null);

    const codigodescuentoprecioRef = useRef(null);
    const codigodescuentoporcentajeRef = useRef(null);

    const formularioreservaRef = useRef(null);

    const datosreservaactualesRef = useRef(null);

    const [importePrepago, setImportePrepago] = useState(0);

    const numpropiedades0Ref = useRef(null);

    const [showHayExtraCat, setShowHayExtraCat] = useState("none");
    const pextracatRef = useRef(null);

    const numtarjetaRef = useRef(null);
    const titulartarjetaRef = useRef(null);
    const fechacaducidadtarjetaRef = useRef(null);
    const cvctarjetaRef = useRef(null);

    const [cardErrors, setCardErrors] = useState({ num: null, expiry: null, cvc: null });

    const luhn = (num) => {
        const digits = num.replace(/\D/g, '');
        if (digits.length < 13 || digits.length > 19) return false;
        let sum = 0;
        let alt = false;
        for (let i = digits.length - 1; i >= 0; i--) {
            let n = parseInt(digits[i], 10);
            if (alt) { n *= 2; if (n > 9) n -= 9; }
            sum += n;
            alt = !alt;
        }
        return sum % 10 === 0;
    };

    const validateExpiry = (val) => {
        const match = val.match(/^(0[1-9]|1[0-2])\/(\d{2})$/);
        if (!match) return false;
        const now = new Date();
        const expMonth = parseInt(match[1], 10);
        const expYear = 2000 + parseInt(match[2], 10);
        return expYear > now.getFullYear() || (expYear === now.getFullYear() && expMonth >= now.getMonth() + 1);
    };

    const formatCardNumber = (e) => {
        const raw = e.target.value.replace(/\D/g, '').slice(0, 16);
        e.target.value = raw.replace(/(.{4})/g, '$1 ').trim();
        numtarjetaRef.current.dataset.raw = raw;
    };

    const handleCardBlur = (field) => {
        const errors = { ...cardErrors };
        if (field === 'num') {
            const raw = (numtarjetaRef.current.dataset.raw || numtarjetaRef.current.value).replace(/\D/g, '');
            errors.num = luhn(raw) ? null : t('Número de tarjeta no válido');
        }
        if (field === 'expiry') {
            errors.expiry = validateExpiry(fechacaducidadtarjetaRef.current.value) ? null : t('Fecha caducada o formato incorrecto (MM/AA)');
        }
        if (field === 'cvc') {
            errors.cvc = /^\d{3,4}$/.test(cvctarjetaRef.current.value) ? null : t('CVV debe tener 3 o 4 dígitos');
        }
        setCardErrors(errors);
    };

    const isCardValid = () =>
        luhn((numtarjetaRef.current?.dataset.raw || numtarjetaRef.current?.value || '').replace(/\D/g, '')) &&
        validateExpiry(fechacaducidadtarjetaRef.current?.value || '') &&
        /^\d{3,4}$/.test(cvctarjetaRef.current?.value || '');

    {/* *************** */ }

    const roundN = (value, decimals) => {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    }

    const handleChangeTarifa = () => {

        console.log("Cambio tarifa " + cantApartRef);

        var precioEstancia = Number(document.querySelector("input[type='radio'][name='tarifa1']:checked").value * cantApartRef);
        //var precioExtras = (Number(sumaExtrasRef.current.value) + Number(sumaExtras2Ref.current.value)) * numreservas;
        var precioExtras = Number(feesRef.current.value);

        var precioTotal = Number(precioEstancia) + Number(precioExtras);

        const tarifaSeleccionada = document.querySelector("input[name='tarifa1']:checked");

        if (!tarifaSeleccionada) return;

        const prepago = Number(
            tarifaSeleccionada.getAttribute('data-prepago') || 0
        );

        if (prepago === 0 && transferencia) {
            const transferenciaRadio = document.getElementById("payments4");
            if (transferenciaRadio) {
                transferenciaRadio.checked = true;
            }
        }

        //console.log("Prepago: " + prepago);

        var totalextratipo2 = 0;

        var nombresextras = "";
        var nombresextras2 = "";

        var extras = document.getElementsByClassName("extra");
        for (var i = 0; i < extras.length; i++) {
            var unextra = extras[i];
            if (unextra.getAttribute('data-tipoextra') === 2) {
                var porciento = unextra.getAttribute('data-precio');
                var precioextra = (precioEstancia * porciento) / 100;
                var valorcampo = unextra.value;
                if (valorcampo == 1) {
                    totalextratipo2 += precioextra;
                }
            }
        }

        var precioextrascal = 0;

        for (var i = 0; i < extras.length; i++) {
            var unextra = extras[i];
            var valorcampo = unextra.value;
            if (unextra.getAttribute("data-nombre") && valorcampo == 1) {
                nombresextras += (nombresextras == "" ? "" : " ") + unextra.getAttribute("data-nombre");

                var precioExtra = parseFloat(unextra.getAttribute('data-precio')) / 100;

                var tipoextra = parseInt(unextra.getAttribute('data-tipoextra'));

                var porreserva = parseInt(unextra.getAttribute('data-porreserva'));
                var porpersona = parseInt(unextra.getAttribute('data-porpersona'));
                var pordia = parseInt(unextra.getAttribute('data-pordia'));
                var pormes = parseInt(unextra.getAttribute('data-pormes'));

                var personas = parseInt(unextra.getAttribute('data-numpersonas'));
                var difdias = parseInt(unextra.getAttribute('data-numdias'));

                if (porreserva) {
                    precioExtra = precioExtra * 1;
                }
                if (porpersona) {
                    precioExtra = precioExtra * personas;
                }
                if (pordia) {
                    precioExtra = precioExtra * difdias;
                }
                if (pormes) {
                    precioExtra = precioExtra * (difdias / 30);
                }
                precioextrascal += precioExtra;

                nombresextras2 += "<div class='col-8'>" + unextra.getAttribute("data-nombre") + "</div><div class='col-4 text-end'>" + precioExtra + " " + moneda + "</div>";

            }
        }

        //pextranombresRef.current.textContent = nombresextras;

        losextrasRef.current.innerHTML = nombresextras2;

        sumaExtras2Ref.current.value = totalextratipo2;

        if (!isNaN(sumaExtrasRef.current.value)) {
            var nuevoPrecioExtras = roundN(precioextrascal, 2) * cantApartRef;
            feesRef.current.value = nuevoPrecioExtras;
        }
        else {
            var nuevoPrecioExtras = 0;
            feesRef.current.value = 0;
        }

        if (!isNaN(sumaExtras2Ref.current.value)) {
            var nuevoPrecioExtrasTipo2 = roundN(sumaExtras2Ref.current.value, 2) * cantApartRef;
            var fees = roundN(feesRef.current.value, 2);

            feesRef.current.value = parseFloat(nuevoPrecioExtrasTipo2) + parseFloat(fees);
            //pextraRef.current.textContent = roundN(parseFloat(fees) + parseFloat(nuevoPrecioExtrasTipo2), 2);
        }
        else {
            var nuevoPrecioExtrasTipo2 = 0;
        }

        var nuevoPrecioTotal = roundN(parseFloat(precioEstancia) + parseFloat(nuevoPrecioExtras) + parseFloat(nuevoPrecioExtrasTipo2), 2);

        let incremento = 0;
        let tipoIncremento = 0;

        const payment = document.querySelector("input[name='payments']:checked");

        if (!payment) {
            return;
        }

        incremento = payment.getAttribute("data-incremento");
        tipoIncremento = payment.getAttribute("data-tipoincremento");

        let incremento2 = incremento;
        if (tipoIncremento === 1) {
            incremento2 = roundN(Number(nuevoPrecioTotal) * ((Number(incremento) / 100)), 2);
        }

        if (incremento > 0) {
            let incremento_a_mostrar = 0;
            if (tipoIncremento === 0) {
                nuevoPrecioTotal = roundN(Number(nuevoPrecioTotal) + Number(incremento), 2);
                incremento_a_mostrar = roundN(Number(incremento), 2);
            } else {
                incremento_a_mostrar = roundN(Number(nuevoPrecioTotal) * (Number(incremento) / 100), 2);
                nuevoPrecioTotal = roundN(Number(nuevoPrecioTotal) * (1 + (Number(incremento) / 100)), 2);
            }
            setShowHayExtraCat("flex");
            pextracatRef.current.textContent = incremento_a_mostrar;
        }
        else {
            setShowHayExtraCat("none");
            pextracatRef.current.textContent = 0;
        }

        var nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
        var nuevoResto = nuevoPrecioTotal - nuevoPrepago;

        var codigoDescuentoPrecio = codigodescuentoprecioRef.current.value;
        var codigoDescuentoPorcentaje = codigodescuentoporcentajeRef.current.value;

        if (codigoDescuentoPrecio > 0 || codigoDescuentoPorcentaje > 0) {
            var precioSinDescuento = nuevoPrecioTotal;
        }
        else {
            var precioSinDescuento = 0.00;
        }
        if (codigoDescuentoPrecio > 0) {
            nuevoPrecioTotal = (nuevoPrecioTotal - codigoDescuentoPrecio).toFixed(2);
            nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
            nuevoResto = nuevoPrecioTotal - nuevoPrepago;
        }
        if (codigoDescuentoPorcentaje > 0) {
            nuevoPrecioTotal = (nuevoPrecioTotal - (precioEstancia * (codigoDescuentoPorcentaje / 100))).toFixed(2);
            nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
            nuevoResto = nuevoPrecioTotal - nuevoPrepago;
        }

        document.querySelectorAll(".pricebase").forEach(function (elemento) {
            elemento.textContent = roundN(Number(precioEstancia), 2) + " " + moneda;
        });

        document.querySelectorAll(".totalprice").forEach(function (elemento) {
            elemento.textContent = roundN(Number(nuevoPrecioTotal), 2) + " " + moneda;
        });

        document.querySelectorAll(".feesincluded").forEach(function (elemento) {
            elemento.textContent = roundN(Number(incremento2), 2)
        });

        //console.log("->" + precioextrascal);
        pextraRef.current.textContent = roundN(Number(precioextrascal), 2);
        //console.log(pextraRef);

        if (codigoDescuentoPrecio > 0 || codigoDescuentoPorcentaje > 0) {
            if (codigoDescuentoPrecio > 0) {
                document.querySelector(".codigo-carro").textContent = "-" + parseFloat(codigoDescuentoPrecio).toFixed(2);
            }
            if (codigoDescuentoPorcentaje > 0) {
                document.querySelector(".codigo-carro").textContent = "-" + (precioEstancia * (codigoDescuentoPorcentaje / 100)).toFixed(2);
            }
        }

        setIdTarifaRef(document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-tarifa"));
        setIdPoliticaRef(document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-idpolitica"));

        //idTarifaRef.current.value = document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-tarifa");

        setPriceRef(btoa(precioEstancia));
        //priceRef.current.value = btoa(precioEstancia);
        setPrepagoRef(prepago);

        nuevoPrepago = (Number(nuevoPrecioTotal) * prepago) / 100;
        nuevoResto = Number(nuevoPrecioTotal) - nuevoPrepago;

        setImportePrepago(nuevoPrepago);

        document.querySelectorAll(".prepago").forEach(function (elemento) {

            if (document.getElementById("payments4") && document.getElementById("payments4").checked) {
                elemento.textContent = ""
                document.getElementById("titulopagar").textContent = t("Confirmar");
                document.getElementById("titulopagarmobile").textContent = t("Confirmar");
                document.getElementById("pagarmoneda").textContent = ""
            }
            else {

                if (nuevoPrepago > 0) {

                    elemento.textContent = roundN(Number(nuevoPrepago), 2)

                    document.getElementById("titulopagar").textContent = t("Pagar") + " " + t("Ahora")
                    document.getElementById("titulopagarmobile").textContent = t("Pagar") + " " + t("Ahora")
                    document.getElementById("pagarmoneda").textContent = moneda
                }
                else {

                    elemento.textContent = ""
                    document.getElementById("titulopagar").textContent = t("Confirmar");
                    document.getElementById("titulopagarmobile").textContent = t("Confirmar")
                    document.getElementById("pagarmoneda").textContent = ""
                }
            }
        });

        //prepagoRef.current.value = prepago;
        preciosDiariosRef.current.value = document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute('data-preciosdiarios');

        datosreservaactualesRef.current.setAttribute("data-precioestancia", (Number(precioEstancia), 2));
        datosreservaactualesRef.current.setAttribute("data-totalprice", roundN(Number(precioTotal), 2));
        datosreservaactualesRef.current.setAttribute("data-prepago", roundN(Number(nuevoPrepago), 2));

        if (prepago === 0) {
            if (document.getElementById("payments1"))
                document.getElementById("payments1").required = false;
            if (document.getElementById("payments2"))
                document.getElementById("payments2").required = false;
        }
        if (prepago > 0) {
            if (document.getElementById("payments1"))
                document.getElementById("payments1").required = true;
            if (document.getElementById("payments2"))
                document.getElementById("payments2").required = true;
            if (document.getElementById("payments5"))
                document.getElementById("payments5").required = true;
            if (document.getElementById("payments6"))
                document.getElementById("payments6").required = true;
        }

        const pagoTransferencia = document.getElementById("payments4") && document.getElementById("payments4").checked;

        const mostrarTarjeta = Number(prepago) < 100 || pagoTransferencia;

        if (mostrarTarjeta) {
            setMostrarInfoTarjeta("block")
            document.getElementById("numtarjeta").required = true;
            document.getElementById("titulartarjeta").required = true;
            document.getElementById("fechacaducidadtarjeta").required = true;
            document.getElementById("cvctarjeta").required = true;
        }
        else {
            setMostrarInfoTarjeta("none");
            document.getElementById("numtarjeta").required = false;
            document.getElementById("titulartarjeta").required = false;
            document.getElementById("fechacaducidadtarjeta").required = false;
            document.getElementById("cvctarjeta").required = false;

        }

    }

    const handleChangeExtra = (param) => {

        var elemento = document.querySelector("select[name='" + param + "']");

        var valor = elemento.value;
        var precioExtra = parseFloat(elemento.getAttribute('data-precio')) / 100;
        var baseExtras = parseFloat(sumaExtrasRef.current.value);
        var baseExtrasTipo2 = parseFloat(sumaExtras2Ref.current.value);

        var precioBase = datosreservaactualesRef.current.getAttribute("data-precioestancia");
        var precioExtraTarifa = datosreservaactualesRef.current.getAttribute("data-precioextratarifa");

        precioBase = precioBase - precioExtraTarifa;

        var tipoextra = parseInt(elemento.getAttribute('data-tipoextra'));

        var porreserva = parseInt(elemento.getAttribute('data-porreserva'));
        var porpersona = parseInt(elemento.getAttribute('data-porpersona'));
        var pordia = parseInt(elemento.getAttribute('data-pordia'));
        var pormes = parseInt(elemento.getAttribute('data-pormes'));

        var personas = parseInt(elemento.getAttribute('data-numpersonas'));
        var difdias = parseInt(elemento.getAttribute('data-numdias'));

        if (porreserva) {
            precioExtra = precioExtra * 1;
        }
        if (porpersona) {
            precioExtra = precioExtra * personas;
        }
        if (pordia) {
            precioExtra = precioExtra * difdias;
        }
        if (pormes) {
            precioExtra = precioExtra * (difdias / 30);
        }

        if (tipoextra === 0) {
            if (valor === "0") {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) - Number(precioExtra), 2);
            }

            else {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) + Number(precioExtra), 2);
            }
        }
        else if (tipoextra === 1) {
            if (valor === "0") {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) - Number(precioExtra), 2);
            }

            else {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) + Number(precioExtra), 2);
            }
        }
        else if (tipoextra === 2) {
            precioExtra = (precioBase * precioExtra) / 100;

            if (valor === "0") {
                sumaExtras2Ref.current.value = roundN(Number(baseExtrasTipo2) - Number(precioExtra), 2);

            }
            else {
                sumaExtras2Ref.current.value = roundN(Number(baseExtrasTipo2) + Number(precioExtra), 2);
            }
        }

        //pextraRef.current.textContent = (parseFloat(sumaExtrasRef.current.value) + parseFloat(sumaExtras2Ref.current.value)) * Number(cantApartRef.current.value);

        feesRef.current.value = (parseFloat(sumaExtrasRef.current.value) + parseFloat(sumaExtras2Ref.current.value)) * Number(cantApartRef);

        handleChangeTarifa();

    }

    const handleChangeNumPropiedades = () => {
        setCantApartRef(numpropiedades0Ref.current.value);
        handleChangeTarifa();
    };

    const handleChangeDiscount = () => {

        var el = document.querySelector('#nombrecodigo');

        let parameters = location.search.substring(1);
        var incrementotpv = 0;

        if (document.querySelector("input[type='radio'][name='payments1']") && document.querySelector("input[type='radio'][name='tarifa1']:checked")) {
            incrementotpv = Number(document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-incremento"));
        }
        if (document.querySelector("#payments2") && document.querySelector("#payments2").checked) {
            incrementotpv = Number(document.querySelector("#payments2").getAttribute("data-incremento"));
        }
        if (document.querySelector("#payments5") && document.querySelector("#payments5").checked) {
            incrementotpv = Number(document.querySelector("#payments5").getAttribute("data-incremento"));
        }

        var precioEstancia = Number(document.querySelector(".tarifa1:checked").value);
        var precioExtras = Number(document.querySelector("#datosreserva").getAttribute('data-extras0'));
        var precioTotal = Number(Number(precioEstancia) + Number(precioExtras));
        var incremento = roundN((precioTotal * (incrementotpv / 100)), 2);
        var preciotpv = roundN((Number(precioTotal) + Number(incremento)), 2);
        var pagoaCuenta = roundN(preciotpv * (Number(document.querySelector(".tarifa1:checked").getAttribute('data-prepago')) / 100), 2);

        const result = axios.post('check-cliente-reserva', {
            idCodigoDescuento: el.value,
            propiedad: propiedad.id,
            entrada: llegada,
            salida: salida,
            parameters: parameters,
            dataType: 'JSON'
        })
            .then((response) => {
                const solucion = response.data;
                if (solucion.status === "success") {
                    var descuento;
                    if (solucion.tipo === 'moneda') {
                        descuento = parseFloat(solucion.descuento).toFixed(2);
                        codigodescuentoprecioRef.current.value = descuento;
                    } else {
                        descuento = (precioEstancia * (solucion.descuento / 100)).toFixed(2);
                        codigodescuentoporcentajeRef.current.value = solucion.descuento;
                    }

                    pagoaCuenta = roundN((preciotpv - descuento) * (Number(document.querySelector(".tarifa1:checked").getAttribute('data-prepago')) / 100), 2);

                    var resto = Number(preciotpv - descuento - pagoaCuenta);

                    document.querySelector('.codigo-carro').innerHTML = "<span>-" + descuento + "</span> ";
                    document.querySelector('.muestra-codigo-carro').style.display = "";
                    document.querySelector('#codigodescuento div').innerHTML = '<div class="ws-errorbox" style="display: block;" id="errorbox-1"><p class="ws-errormessage c008">Codigo de descuento valido.</p></div>';
                    document.querySelector('.prepago').textContent = roundN(Number(pagoaCuenta), 2) + " " + moneda;
                    handleChangeTarifa();
                }
                else {
                    codigodescuentoprecioRef.current.value = "";
                    codigodescuentoporcentajeRef.current.value = "";
                    var resto = preciotpv - pagoaCuenta;
                    document.querySelector('.muestra-codigo-carro').style.display = "none";
                    document.querySelector('.codigo-carro').textContent = '';
                    document.querySelector('#codigodescuento div').innerHTML = '<div class="ws-errorbox" style="display: block;" id="errorbox-1"><p class="ws-errormessage">Codigo de descuento no valido.</p></div>';
                    document.querySelector('.prepago').textContent = roundN(Number(pagoaCuenta), 2) + " " + moneda;
                    handleChangeTarifa();
                }
            })
    };

    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => {
        setShowModal(!showModal);
    }

    const [enviando, setEnviando] = useState(false);

    const handleSubmit = async () => {

        console.log("hago submit");

        if (nombrecRef.current.value && nombrecRef.current.value.replace(/\s+/g, '').length > 0 &&
            apellidoscRef.current.value && apellidoscRef.current.value.replace(/\s+/g, '').length > 0 &&
            emailcRef.current.value && emailcRef.current.value.replace(/\s+/g, '').length > 0 &&
            telefonocRef.current.value && phoneNumber.replace(/\s+/g, '').length > 0 &&
            documentocRef.current.value && documentocRef.current.value.replace(/\s+/g, '').length > 0 &&
            aceptacondicionesRef.current.checked && emailcRef.current.value.includes('@')) {
            if (prepagoRef < 100) {
                if (titulartarjetaRef.current.value.trim().length > 0 && isCardValid()) {
                    const raw = (numtarjetaRef.current.dataset.raw || numtarjetaRef.current.value).replace(/\D/g, '');
                    numtarjetaRef.current.value = raw;
                    setEnviando(true);
                    formularioreservaRef.current.submit();
                }
                else {
                    handleShowModal()
                }
            }
            else {
                setEnviando(true);
                formularioreservaRef.current.submit();
            }
        }
        else {
            handleShowModal()
        }
    }

    const handleBack = () => {
        window.history.back();
    }

    useEffect(() => {

        if (document.getElementById("payments2")) {
            document.getElementById("payments2").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.getElementById("payments5")) {
            document.getElementById("payments5").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }


        if (document.getElementById("payments4")) {
            document.getElementById("payments4").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.querySelector(".tpv")) {
            document.querySelector(".tpv").click(function () {
                handleChangeTarifa();
            });
        }

        if (document.querySelector(".bizum")) {
            document.querySelector(".bizum").click(function () {
                handleChangeTarifa();
            });
        }

        setTimeout(() => {
            handleChangeTarifa();
        }, 0);

    }, []);

    const [showMore, setshowMore] = useState(-1);

    let lostpvs = [];
    let losstripes = [];

    {/* *************** */ }

    let nombreobligatorios = "";
    propiedad.relacion_extras.map((unextra, index) => {
        if (unextra.obligatorio) {
            if (nombreobligatorios != "") nombreobligatorios += ", "
            nombreobligatorios += unextra.nombre
        }
    })


    {/* *************** */ }
    // 1. Primero, define el estado y la función para manejar los cambios
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        documentousuario: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    {/* *************** Prefijo telefónico *************** */ }

    const isoToFlag = (iso) => {
        if (!iso || iso.length !== 2) return '🌐';
        return String.fromCodePoint(...[...iso.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)));
    };

    const [selectedCountry, setSelectedCountry] = useState(paises && paises.length > 0 ? paises[0] : null);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneDropdownOpen, setPhoneDropdownOpen] = useState(false);
    const [phoneSearch, setPhoneSearch] = useState('');

    const filteredPaises = (paises || []).filter((unpais) =>
        unpais.nombre.toLowerCase().includes(phoneSearch.toLowerCase())
    );

    useEffect(() => {
        const prefijo = selectedCountry ? selectedCountry.prefijo : '';
        setFormData((prev) => ({ ...prev, phone: (prefijo + phoneNumber).trim() }));
    }, [selectedCountry, phoneNumber]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (phoneDropdownRef.current && !phoneDropdownRef.current.contains(e.target)) {
                setPhoneDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    {/* *************** */ }

    // 2. Calcula si el formulario es válido
    const isFormValid = formData.firstname && formData.lastname &&
        formData.email && phoneNumber.trim().length > 0 &&
        formData.documentousuario;

    {/* *************** */ }

    useEffect(() => {
        if (mostrarInfoPago === "block") {
            setTimeout(() => {
                handleChangeTarifa();
            }, 0);
        }
    }, [mostrarInfoPago, prepagoRef, cantApartRef]);

    {/* *************** */ }

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-7 col-lg-8">

                    <form method="post" action="/resumen" id="formularioreserva" ref={formularioreservaRef} onSubmit={handleSubmit}>
                        <input type="hidden" name="_token" value={token} />

                        <input type="hidden" name="idpropiedad" id="idPropiedad" defaultValue={propiedad.id} />
                        <input type="hidden" name="llegada" defaultValue={llegada} id="llegada" />
                        <input type="hidden" name="salida" defaultValue={salida} id="salida" />
                        <input type="hidden" name="adultos" defaultValue={adultos} />
                        <input type="hidden" name="ninos" defaultValue={ninos} />
                        <input type="hidden" name="bebes" defaultValue={bebes} />
                        <input type="hidden" name="price" id="price" defaultValue={priceRef} />
                        <input type="hidden" name="discount" id="discount" defaultValue="0" />
                        <input type="hidden" name="fees" id="fees" defaultValue={propiedad.fees / 100} ref={feesRef} />
                        <input type="hidden" name="idusuario" id="user" defaultValue="" />
                        <input type="hidden" name="difdias" defaultValue={difdias} />

                        <input type="hidden" name="prepago" id="prepago" defaultValue={prepagoRef} />
                        <input type="hidden" name="solorequest" id="solorequest" defaultValue="0" />
                        <input type="hidden" name="idTarifa" id="idTarifa" defaultValue={idTarifaRef} />
                        <input type="hidden" name="cantidadAparts" id="cantidadAparts" defaultValue={cantApartRef} />
                        <input type="hidden" name="idpolitica" id="idpolitica" defaultValue={idPoliticaRef} />

                        <input type="hidden" name="preciosDiarios" id="preciosDiarios" defaultValue="" ref={preciosDiariosRef} />

                        {/* ***************** EXTRES ***************** */}

                        <div className="metro-box-wrapper" style={{ display: mostrarExtras }}>
                            <h3>{t("Extras")}</h3>
                            <div className="linia"></div>

                            <div className="content">
                                <p className="text-muted">{t("Mejore su estancia con los siguientes extras.")}</p>

                                {propiedad.relacion_extras.map((unextra, index) => {

                                    let baseprecio = unextra.precio;
                                    let dias_a_multiplicar = Math.min(difdias, propiedad.destino.maximo_dias);

                                    if (unextra.obligatorio) {
                                        let tipo_precio = unextra.tipo_precio;
                                        if (tipo_precio === "1") {
                                            if (unextra.por_persona === 1) {
                                                baseprecio = baseprecio * (Number(adultos) + Number(ninos))
                                            }
                                            if (unextra.por_dia_reserva === 1) {
                                                baseprecio = baseprecio * difdias;
                                            }
                                        }
                                        else {
                                            baseprecio = precioBase * (baseprecio / 100);
                                            if (unextra.por_persona === 1) {
                                                baseprecio = baseprecio * (Number(adultos) + Number(ninos))
                                            }
                                            if (unextra.por_dia_reserva === 1) {
                                                baseprecio = baseprecio * dias_a_multiplicar;
                                            }
                                        }
                                        sumaextras += (baseprecio / 100)
                                    }

                                    if (unextra.incluido) return null;

                                    const periodo = unextra.por_reserva ? " / " + t("Por reserva")
                                        : unextra.por_persona ? " / " + t("Por persona")
                                            : unextra.por_dia_reserva ? " / " + t("Por dia")
                                                : unextra.por_mes_reserva ? " / " + t("Por mes")
                                                    : "";

                                    return (
                                        <div className="gap-3 p-3 mb-3 bg-white border rounded-3 d-flex align-items-center serveismotor" key={"e" + index} data-key={"e" + index}>
                                            <div className="flex-shrink-0 p-3 d-flex align-items-center justify-content-center bg-light rounded-3">
                                                {unextra.imagen ?
                                                    <i className={unextra.imagen.replace("fa-lg", "") + " fa-xl text-secondary"}></i>
                                                    :
                                                    <i className="fa-duotone fa-check fa-xl text-secondary"></i>
                                                }
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="fw-semibold">{unextra.nombre}</div>
                                                {!unextra.obligatorio &&
                                                    <div className="text-muted small">
                                                        <strong>{(baseprecio / 100).toFixed(2)} {moneda}</strong>{periodo}
                                                    </div>
                                                }
                                            </div>
                                            {!!unextra.descripcion &&
                                                <div className="text-center flex-grow-1 text-muted small">{unextra.descripcion}</div>
                                            }
                                            <div className="flex-shrink-0">
                                                {unextra.obligatorio ?
                                                    <span className="px-2 py-1 border badge bg-light text-success border-success">
                                                        {t("Incluido")}
                                                    </span>
                                                    :
                                                    <div className="mb-0 form-check form-switch switch-lg">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            role="switch"
                                                            defaultChecked={false}
                                                            onChange={(e) => {
                                                                document.querySelector(`select[name="extra${unextra.servicios_extra_id}"]`).value = e.target.checked ? "1" : "0";
                                                                handleChangeExtra("extra" + unextra.servicios_extra_id);
                                                            }}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            <select
                                                className="d-none extra"
                                                name={"extra" + unextra.servicios_extra_id}
                                                disabled={unextra.obligatorio ? true : false}
                                                data-dialimpieza=""
                                                data-nombre={unextra.nombre}
                                                data-extraid={unextra.servicios_extra_id}
                                                data-precio={baseprecio}
                                                data-porreserva={unextra.por_reserva ? 1 : 0}
                                                data-porpersona={unextra.por_persona ? 1 : 0}
                                                data-pordia={unextra.por_dia_reserva ? 1 : 0}
                                                data-pormes={unextra.por_mes_reserva ? 1 : 0}
                                                data-numdias={difdias}
                                                data-numpersonas={Number(adultos) + Number(ninos)}
                                                data-tipoextra={unextra.tipo}
                                                defaultValue={unextra.obligatorio ? 1 : 0}
                                            //onChange={() => handleChangeExtra("extra" + unextra.servicios_extra_id)}
                                            >
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                            </select>
                                            {!!unextra.obligatorio &&
                                                <input type="hidden" name={"extra" + unextra.servicios_extra_id} defaultValue={1} />
                                            }
                                        </div>
                                    );
                                })}

                                <input type="hidden" name="baseextras" id="baseextras" defaultValue={sumaextras} ref={sumaExtrasRef} />
                                <input type="hidden" name="baseextrastipo2" id="baseextrastipo2" defaultValue="0" ref={sumaExtras2Ref} />
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                {tarifa || precios.length == 1 ?
                                    <button type="button"
                                        onClick={toggleTarifasDescuento}
                                        className="btn btn-primary"
                                        style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                    >
                                        {t("Siguiente")} →
                                    </button>
                                    :
                                    <button type="button"
                                        onClick={toggleTarifas}
                                        className="btn btn-primary"
                                        style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                    >
                                        {t("Siguiente")} →
                                    </button>
                                }
                            </div>
                        </div>


                        {/* ***************** FINAL EXTRES ***************** */}

                        { /*-- ********************** TARIFES  ********************************* */}

                        <div className="metro-box-wrapper" style={{ display: mostrarTarifas }}>
                            <h3>{t("Tarifas")}</h3>
                            <div className="linia"></div>
                            <div className="content">
                                {precios.map((unprecio, index) => {

                                    let acumulado = unprecio.suma / 100;
                                    let checked = ""
                                    let preciosdiarios = unprecio.calendario_sin_otas
                                    for (let i = 0; i < preciosdiarios.length; i++) {
                                        if (index === 0) cuentaNoches++;
                                    }
                                    if (index === 0) {
                                        precioBase = acumulado.toFixed(2);
                                    }

                                    acumulado = acumulado.toFixed(2);
                                    resprices = resprices.concat(
                                        <div className="tarifes" key={"tarifa" + index} data-key={"tarifa" + index}>
                                            <div className="content">
                                                <div className="mt-radio-list m15_1_1_1">
                                                    <label className="mt-radio radiotarifa">
                                                        {index === 0 ?
                                                            <input type="radio"
                                                                name="tarifa1"
                                                                className="tarifa1"
                                                                defaultChecked
                                                                id="tarifa"
                                                                defaultValue={acumulado}
                                                                data-preciosdiarios=""
                                                                data-prepago={unprecio.info_tarifa.politica.prepago}
                                                                data-idpolitica={unprecio.info_tarifa.politica_id}
                                                                data-tarifa={unprecio.id}
                                                                data-texto={unprecio.info_tarifa.politica.descripcion[lang]} onClick={() => handleChangeTarifa()}
                                                            />
                                                            :
                                                            <input type="radio"
                                                                name="tarifa1"
                                                                className="tarifa1"
                                                                id="tarifa"
                                                                defaultValue={acumulado}
                                                                data-preciosdiarios=""
                                                                data-prepago={unprecio.info_tarifa.politica.prepago}
                                                                data-idpolitica={unprecio.info_tarifa.politica_id}
                                                                data-tarifa={unprecio.id}
                                                                data-texto={unprecio.info_tarifa.politica.descripcion[lang]} onClick={() => handleChangeTarifa()}
                                                            />
                                                        }
                                                        <strong>{" " + acumulado + " " + moneda}  </strong> - {" "}{unprecio.info_tarifa.nombre_web_traducido?.[lang] ? unprecio.info_tarifa.nombre_web_traducido[lang] : unprecio.info_tarifa.nombre_web}
                                                    </label>
                                                    <p className="small ms-3"
                                                        onClick={() => { showMore == index ? setshowMore(-1) : setshowMore(index) }}
                                                    >
                                                        <span className="small bolder">{unprecio.info_tarifa.politica.nombre[lang]}</span> <span className="cursor-pointer small bolder fst-italic">({showMore == index ? t('Esconder') : t('Mostrar')} {t('Descripción')})</span>
                                                    </p>
                                                    {showMore === index && (
                                                        <>
                                                            <hr className="mt-0" />
                                                            <p className="small" dangerouslySetInnerHTML={{ __html: limpiarHtml(unprecio.info_tarifa.politica.descripcion[lang]) }}></p>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                                {resprices}
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                {propiedad.relacion_extras.length > 0 &&
                                    <button type="button"
                                        onClick={toggleExtresTarifas}
                                        className="btn btn-outline-secondary"
                                    >
                                        ← {t("Anterior")}
                                    </button>
                                }
                                <button type="button"
                                    onClick={toggleTarifasDescuento}
                                    className="btn btn-primary"
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {t("Siguiente")} →
                                </button>
                            </div>

                        </div>

                        { /*-- ********************** FINAL TARIFES  ********************************* */}

                        {/* ***************** CODI DESCOMPTE ***************** */}
                        <div className="metro-box-wrapper" style={{ display: mostrarDescuento }}>
                            <h3>{t("Código promocional")}</h3>
                            <div className="linia"></div>

                            <div className="gap-2 p-3 mt-5 mb-4 border border-opacity-25 d-flex align-items-start rounded-3 bg-primary bg-opacity-10 border-primary">
                                <i className="flex-shrink-0 mt-1 fa-duotone fa-circle-info fa-lg text-primary"></i>
                                <small className="text-secondary fw-normal lh-base">
                                    {t("Si dispones de un código de descuento, introdúcelo en el campo correspondiente. El importe se actualizará automáticamente antes de confirmar tu reserva.")}
                                </small>
                            </div>

                            <div className="content">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-8 col-lg-6">
                                        <label className="mb-2 form-label fw-normal">{t("Código de descuento")}</label>
                                        <div id="codigodescuento" className="input-group">
                                            <input type="text" className="form-control" placeholder={t("Introduce tu código")} name="codigodescuento" id="nombrecodigo" onKeyUp={handleChangeDiscount} />
                                            <span className="input-group-text">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M4 4.85v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.9v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.9v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.9v.9h1v-.9zm7 0v.9h1v-.9z" />
                                                    <path d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3zM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <input type="hidden" id="codigodescuentoprecio" name="codigodescuentoprecio" defaultValue="" ref={codigodescuentoprecioRef} />
                                        <input type="hidden" id="codigodescuentoporcentaje" name="codigodescuentoporcentaje" defaultValue="" ref={codigodescuentoporcentajeRef} />
                                        <input type="hidden" name="moneda2" defaultValue={moneda} />
                                        <input type="hidden" name="abreviaturamoneda2" defaultValue="EUR" />
                                    </div>
                                </div>
                            </div>

                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center align-items-center">
                                {tarifa && propiedad.relacion_extras.length > 0 ?
                                    <button type="button"
                                        onClick={toggleExtresTarifas}
                                        className="btn btn-outline-secondary"
                                    >
                                        ← {t("Anterior")}
                                    </button>
                                    :
                                    !tarifa && precios.length > 1 ?
                                        <button type="button"
                                            onClick={toggleDescuentoTarifas}
                                            className="btn btn-outline-secondary"
                                        >
                                            ← {t("Anterior")}
                                        </button>
                                        :
                                        !tarifa && propiedad.relacion_extras.length > 0 ?
                                            <button type="button"
                                                onClick={toggleExtresTarifas}
                                                className="btn btn-outline-secondary"
                                            >
                                                ← {t("Anterior")}
                                            </button>
                                            :
                                            <div></div>
                                }
                                <button type="button"
                                    onClick={toggleDescuentoDadesClient}
                                    className="btn btn-primary"
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {t("Siguiente")} →
                                </button>
                            </div>

                        </div>
                        {/* ***************** FINAL CODI DESCOMPTE ***************** */}

                        {/* ***************** DADES CLIENT ***************** */}

                        <div className="metro-box-wrapper" id="userInfo" style={{ display: mostrarDadesClient }}>
                            <h3>{t("Información de cobro")}</h3>
                            <div className="linia"></div>
                            <div className="content">
                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Nombre")} *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Nombre")}
                                            name="firstname"
                                            required
                                            value={formData.firstname}
                                            onChange={handleInputChange}
                                            id="nombrec"
                                            ref={nombrecRef}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Apellidos")} *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Apellidos")}
                                            name="lastname"
                                            required
                                            value={formData.lastname}
                                            onChange={handleInputChange}
                                            id="apellidosc"
                                            ref={apellidoscRef}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Email")} *</label>
                                        <input
                                            id="emailc"
                                            type="email"
                                            className="form-control"
                                            placeholder={t("Email")}
                                            name="email"
                                            required
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            ref={emailcRef}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Teléfono")} *</label>
                                        <div className="d-flex position-relative" ref={phoneDropdownRef}>
                                            <button
                                                type="button"
                                                className="gap-2 px-2 border btn d-flex align-items-center"
                                                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 'none' }}
                                                onClick={() => setPhoneDropdownOpen((prev) => !prev)}
                                            >
                                                <span>{isoToFlag(selectedCountry?.iso)}</span>
                                                <span>{selectedCountry?.prefijo || ''}</span>
                                                <i className="fa-solid fa-chevron-down fa-xs"></i>
                                            </button>
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                placeholder={t("Teléfono")}
                                                required
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                id="telefonoc"
                                            />
                                            <input type="hidden" name="phone" value={formData.phone} ref={telefonocRef} />

                                            {phoneDropdownOpen &&
                                                <div className="bg-white border shadow-sm position-absolute rounded-3" style={{ top: '100%', left: 0, zIndex: 1000, width: '280px', marginTop: '4px' }}>
                                                    <div className="p-2 border-bottom">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder={t("Buscar")}
                                                            value={phoneSearch}
                                                            onChange={(e) => setPhoneSearch(e.target.value)}
                                                            autoFocus
                                                        />
                                                    </div>
                                                    <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                                                        {filteredPaises.map((unpais) => (
                                                            <div
                                                                key={unpais.id}
                                                                className="gap-2 px-3 py-2 cursor-pointer d-flex align-items-center"
                                                                style={{ cursor: 'pointer' }}
                                                                onMouseDown={() => {
                                                                    setSelectedCountry(unpais);
                                                                    setPhoneDropdownOpen(false);
                                                                    setPhoneSearch('');
                                                                }}
                                                            >
                                                                <span>{isoToFlag(unpais.iso)}</span>
                                                                <span>{unpais.nombre}</span>
                                                                <span className="text-muted ms-auto small">{unpais.prefijo}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Pasaporte/ID")} *</label>
                                        <input
                                            id="documentoc"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Pasaporte/ID")}
                                            name="documentousuario"
                                            required
                                            value={formData.documentousuario}
                                            onChange={handleInputChange}
                                            ref={documentocRef}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Ciudad")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Ciudad")}
                                            name="city"
                                            defaultValue=""
                                        />
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <label className="mt-1 col-md-6 col-lg-2">{t("Comentario")}</label>
                                        <div className="mb-2 col-md-6 col-lg-12">
                                            <textarea id="comentario" className="mb-0 form-control" rows="4" placeholder={t("Comentario")} name="comentario"> </textarea>
                                        </div>
                                    </div>
                                    <div className="col-12 text-end">
                                        <small className="text-muted">{t("Todos los campos * son obligatorios")}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                <button type="button"
                                    onClick={toggleDadesClientDescuento}
                                    className="btn btn-outline-secondary"
                                >
                                    ← {t("Anterior")}
                                </button>
                                <button
                                    type="button"
                                    onClick={isFormValid ? toggleDadesClientInfoPago : undefined}
                                    className={`btn btn-primary${!isFormValid ? ' disabled' : ''}`}
                                    disabled={!isFormValid}
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {t("Siguiente")} →
                                </button>
                            </div>
                        </div>

                        {/* ***************** FINAL DADES CLIENT ***************** */}

                        {/* ***************** TPV, PAYPAL, ETC ***************** */}
                        <div className="metro-box-wrapper tipopago" style={{ display: mostrarInfoPago }}>
                            <h3>{t("Información de pago")}</h3>
                            <div className="linia"></div>
                            <div className="content">
                                <div id="paymentOption" className="payment-option-wrapper">
                                    <div className="row">
                                        {config.activa_tpv === 1 && tpvs.length > 0 && prepagoRef > 0 ?
                                            tpvs.map((untpv, index) => {
                                                lostpvs = lostpvs.concat(
                                                    <>
                                                        <div className="col-lg-6 col-md-12" key={"tpv" + index} data-key={"tpv" + index}>
                                                            <div className="radio-block font-icon-radio">
                                                                <input className="payments1 radio tpv"
                                                                    id="elem0" name="payments"
                                                                    type="radio"
                                                                    defaultValue={"paymentsCreditCard" + untpv.id}
                                                                    required=""
                                                                    data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                    data-idtpv={untpv.id}
                                                                    data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                    onClick={() => handleChangeTarifa()}
                                                                    defaultChecked={index === 0}
                                                                />
                                                                <label htmlFor="elem0">

                                                                    {untpv.nombre_comercio} <i className="fa-brands fa-cc-visa fa-xl"></i>

                                                                </label>
                                                            </div>
                                                        </div>

                                                        {untpv.bizum == 1 ?
                                                            <>
                                                                <div className='col-lg-6 col-md-12' key={"bizum" + index} data-key={"bizum" + index}>
                                                                    <div className='radio-block font-icon-radio'>
                                                                        <input className='payments1 radio tpv'
                                                                            id='elem2-0'
                                                                            name='payments'
                                                                            type='radio'
                                                                            value={"paymentsBizum" + untpv.id}
                                                                            required=""
                                                                            data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                            data-idtpv={untpv.id}
                                                                            data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                            onClick={() => handleChangeTarifa()}
                                                                        />
                                                                        <label htmlFor='elem2-0'>

                                                                            {t("Bizum")} <i className="fa-duotone fa-mobile fa-xl"></i>

                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            <></>
                                                        }

                                                        {untpv.google_pay == 1 ?
                                                            <>
                                                                <div className='col-lg-6 col-md-12' key={"gp" + index}>
                                                                    <div className='radio-block font-icon-radio'>
                                                                        <input className='payments1 radio tpv'
                                                                            id='elem2-0'
                                                                            name='payments'
                                                                            type='radio'
                                                                            value={"paymentsGPay" + untpv.id}
                                                                            required=""
                                                                            data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                            data-idtpv={untpv.id}
                                                                            data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                            onClick={() => handleChangeTarifa()}
                                                                        />
                                                                        <label htmlFor='elem2-0'>

                                                                            {t("Google")} <i className="fa-brands fa-google-pay fa-2xl ms-2"></i>

                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            <></>
                                                        }

                                                        {untpv.apple_pay == 1 ?
                                                            <>
                                                                <div className='col-lg-6 col-md-12' key={"ap" + index}>
                                                                    <div className='radio-block font-icon-radio'>
                                                                        <input className='payments1 radio tpv'
                                                                            id='elem2-0'
                                                                            name='payments'
                                                                            type='radio'
                                                                            value={"paymentsAPay" + untpv.id}
                                                                            required=""
                                                                            data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                            data-idtpv={untpv.id}
                                                                            data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                            onClick={() => handleChangeTarifa()}
                                                                        />
                                                                        <label htmlFor='elem2-0'>

                                                                            {t("Apple")} <i className="fa-brands fa-apple-pay fa-2xl ms-2"></i>

                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            <></>
                                                        }
                                                    </>
                                                )
                                            })
                                            :
                                            lostpvs = lostpvs.concat(<></>)
                                        }
                                        {lostpvs}
                                        {config.activa_paypal === 1 && paypal && prepagoRef > 0 ?
                                            <>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="radio-block font-icon-radio">
                                                        <input id="payments2"
                                                            name="payments"
                                                            type="radio"
                                                            className="radio"
                                                            value="paymentPaypal"
                                                            required=""
                                                            data-incremento={paypal.markup.incremento}
                                                            data-tipoincremento={paypal.markup.tipo}
                                                            onClick={() => handleChangeTarifa()}
                                                            defaultChecked={tpvs.length === 0}
                                                        />
                                                        <label htmlFor="payments2">

                                                            {t("Paypal")} <i className="fa-brands fa-paypal fa-xl"></i>

                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }

                                        {config.activa_stripe === 1 && stripe.length > 0 && prepagoRef > 0 ?
                                            stripe.map((unstripe, index) => {
                                                losstripes = losstripes.concat(
                                                    <>
                                                        <div className="col-lg-6 col-md-12" key={"str" + index} data-key={"str" + index}>
                                                            <div className="radio-block font-icon-radio">
                                                                <input className="payments5 radio"
                                                                    name="payments"
                                                                    type="radio"
                                                                    value={"paymentStripe" + unstripe.id}
                                                                    required=""
                                                                    data-incremento={unstripe.markup.incremento}
                                                                    data-tipoincremento={unstripe.markup.tipo}
                                                                    onClick={() => handleChangeTarifa()}
                                                                    defaultChecked={tpvs.length === 0 && config.activa_paypal === 0}
                                                                    id="payments5"
                                                                />
                                                                <label htmlFor="payments5">

                                                                    {unstripe.nombre_comercio && unstripe.nombre_comercio != '' ? unstripe.nombre_comercio : "Stripe"} <i className="fa-brands fa-stripe fa-xl"></i>

                                                                </label>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })
                                            :
                                            losstripes = losstripes.concat(<></>)
                                        }
                                        {losstripes}

                                        {config.activa_transferencia === 1 && transferencia ?
                                            <>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="radio-block font-icon-radio">
                                                        <input id="payments4"
                                                            name="payments"
                                                            type="radio"
                                                            className="radio"
                                                            value="paymentTransferencia"
                                                            required=""
                                                            onClick={() => handleChangeTarifa()}
                                                            defaultChecked={(tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0) || prepagoRef === 0}
                                                        />
                                                        <label htmlFor="payments4">

                                                            {transferencia.nombre_web} <i className="fa-duotone fa-building fa-xl"></i>

                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        {config.activa_paycomet === 1 && paycomet && prepagoRef > 0 ?
                                            <>
                                                {
                                                    Object.keys(paycomet.metodos_pago).map((key) => (
                                                        <div className="col-lg-6 col-md-12" key={"pc" + key} data-key={"pc" + key}>
                                                            <div className="radio-block font-icon-radio">
                                                                <input id="payments6"
                                                                    name="payments"
                                                                    type="radio"
                                                                    className="radio payments6"
                                                                    value={"paymentPaycomet" + key}
                                                                    required=""
                                                                    onClick={() => handleChangeTarifa()}
                                                                    defaultChecked={tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0 && config.activa_transferencia === 0 && key == 1}
                                                                />
                                                                <label htmlFor="payments6">

                                                                    {paycomet.metodos_pago[key].nombre}
                                                                    {
                                                                        paycomet.metodos_pago[key].nombre === "Tarjeta" ?
                                                                            <i className="fa-brands fa-cc-visa fa-xl ms-2"></i>
                                                                            :
                                                                            paycomet.metodos_pago[key].nombre === "PayPal" ?
                                                                                <i className="fa-brands fa-paypal fa-xl ms-2"></i>
                                                                                :
                                                                                <i className="fa-duotone fa-mobile fa-xl ms-2"></i>
                                                                    }

                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    paycomet.apple_pay === 1 ?
                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="radio-block font-icon-radio">
                                                                <input id="payments6"
                                                                    name="payments"
                                                                    type="radio"
                                                                    className="radio payments6"
                                                                    value="paymentPaycomet1"
                                                                    required=""
                                                                    onClick={() => handleChangeTarifa()}
                                                                />
                                                                <label htmlFor="payments6">

                                                                    {t("Apple")} <i className="fa-brands fa-apple-pay fa-2xl ms-2"></i>

                                                                </label>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    paycomet.google_pay === 1 ?
                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="radio-block font-icon-radio">
                                                                <input id="payments6"
                                                                    name="payments"
                                                                    type="radio"
                                                                    className="radio payments6"
                                                                    value="paymentPaycomet1"
                                                                    required=""
                                                                    onClick={() => handleChangeTarifa()}
                                                                />
                                                                <label htmlFor="payments6">

                                                                    {t("Google")} <i className="fa-brands fa-google-pay fa-2xl ms-2"></i>

                                                                </label>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </>
                                            :
                                            <></>
                                        }



                                        <div className="p-4 mt-4 col-md-12 serveismotor" style={{ display: mostrarInfoTarjeta }}>
                                            <div className="gap-2 p-3 mt-2 mb-5 border border-opacity-25 d-flex align-items-start rounded-3 bg-primary bg-opacity-10 border-primary">
                                                <i className="flex-shrink-0 mt-1 fa-duotone fa-circle-info fa-lg text-primary"></i>
                                                <small className="text-secondary fw-normal lh-base">
                                                    {t("No te cobraremos nada todavía. Solo necesitamos los datos de la tarjeta para garantizar tu reserva.")}
                                                </small>
                                            </div>
                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <label className="text-black form-label fw-bolder">{t("Titular de la tarjeta")} *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t("Titular de la tarjeta")}
                                                        name="titular_tarjeta"
                                                        onChange={handleInputChange}
                                                        id="titulartarjeta"
                                                        ref={titulartarjetaRef}
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <label className="text-black form-label fw-bolder">{t("Número de tarjeta")} *</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control${cardErrors.num === null && numtarjetaRef.current?.value ? ' is-valid' : cardErrors.num ? ' is-invalid' : ''}`}
                                                        placeholder="0000 0000 0000 0000"
                                                        name="num_tarjeta"
                                                        id="numtarjeta"
                                                        inputMode="numeric"
                                                        maxLength="19"
                                                        ref={numtarjetaRef}
                                                        onChange={formatCardNumber}
                                                        onBlur={() => handleCardBlur('num')}
                                                    />
                                                    {cardErrors.num && <div className="invalid-feedback">{cardErrors.num}</div>}
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="text-black form-label fw-bolder">{t("Fecha caducidad")} *</label>
                                                    <input
                                                        id="fechacaducidadtarjeta"
                                                        type="text"
                                                        className={`form-control${cardErrors.expiry === null && fechacaducidadtarjetaRef.current?.value ? ' is-valid' : cardErrors.expiry ? ' is-invalid' : ''}`}
                                                        placeholder="MM/AA"
                                                        name="fecha_caducidad"
                                                        maxLength="5"
                                                        inputMode="numeric"
                                                        ref={fechacaducidadtarjetaRef}
                                                        onChange={(e) => {
                                                            let v = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                            if (v.length >= 3) v = v.slice(0, 2) + '/' + v.slice(2);
                                                            e.target.value = v;
                                                        }}
                                                        onBlur={() => handleCardBlur('expiry')}
                                                    />
                                                    {cardErrors.expiry && <div className="invalid-feedback">{cardErrors.expiry}</div>}
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="text-black form-label fw-bolder">{t("CVV / CVC")} *</label>
                                                    <input
                                                        type="password"
                                                        className={`form-control${cardErrors.cvc === null && cvctarjetaRef.current?.value ? ' is-valid' : cardErrors.cvc ? ' is-invalid' : ''}`}
                                                        placeholder="•••"
                                                        name="cvc_tarjeta"
                                                        maxLength="4"
                                                        inputMode="numeric"
                                                        id="cvctarjeta"
                                                        ref={cvctarjetaRef}
                                                        onChange={handleInputChange}
                                                        onBlur={() => handleCardBlur('cvc')}
                                                    />
                                                    {cardErrors.cvc && <div className="invalid-feedback">{cardErrors.cvc}</div>}
                                                </div>
                                                <div className="mt-4 col-12">
                                                    <div className="gap-3 p-3 border border-opacity-25 d-flex align-items-center justify-content-center rounded-3 bg-success bg-opacity-10 border-success">
                                                        <i className="fa-duotone fa-shield-check fa-xl text-success"></i>
                                                        <div>
                                                            <div className="fw-semibold text-success small">{t("Pago 100% seguro")}</div>
                                                            <div className="text-muted" style={{ fontSize: "0.75rem" }}>{t("Tus datos están cifrados y protegidos con SSL")}</div>
                                                        </div>
                                                        <i className="fa-brands fa-cc-visa fa-xl text-secondary"></i>
                                                        <i className="fa-brands fa-cc-mastercard fa-xl text-secondary"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                <button type="button"
                                    onClick={toggleDadesInfoPagoClient}
                                    className="btn btn-outline-secondary"
                                >
                                    ← {t("Anterior")}
                                </button>
                                <button className="btn btn-primary"
                                    //onClick={() => ()}
                                    type="submit"
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {prepagoRef > 0 ?
                                        <>
                                            <i className="fa-duotone fa-credit-card me-1"></i>
                                            <span id="titulopagarmobile">{t("Pagar") + " " + t("Ahora")}</span>
                                        </>
                                        :
                                        <span id="titulopagarmobile">{t("Confirmar")}</span>
                                    }
                                </button>
                            </div>
                        </div>

                        {/* ***************** FIN TPV, PAYPAL, ETC ***************** */}
                    </form>

                    {modalPolitica && (
                        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setModalPolitica(null)}>
                            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                                <div className="modal-content">
                                    <div className="pb-0 border-0 modal-header">
                                        <h6 className="modal-title fw-bolder">{modalPolitica.nombre}</h6>
                                        <button type="button" className="btn-close" onClick={() => setModalPolitica(null)}></button>
                                    </div>
                                    <div className="pt-2 modal-body">
                                        <p className="mb-0 small text-muted" dangerouslySetInnerHTML={{ __html: limpiarHtml(modalPolitica.descripcion) }}></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <Modal
                        show={showModal} onHide={() => setShowModal(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{t("Error")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="clearfix mb-20 ml-20 row">
                                {t("Asegúrate de completar los campos marcados con *")}
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>


                <div className="col-md-5 col-lg-4">
                    <div className="mt-5 caixa-preus sticky-top">
                        {(() => {
                            const tarifaSel = precios.find((p) => p.id == idTarifaRef) || precios[0];
                            const politica = tarifaSel.info_tarifa.politica;
                            const nombretarifa = tarifaSel.info_tarifa.nombre_web_traducido?.[lang] || tarifaSel.info_tarifa.nombre_web;
                            return (
                                <div className="bh-cart">
                                    <div className="bh-cart__item">
                                        <div className="bh-cart__top">
                                            <div className="bh-cart__foto">
                                                {
                                                    propiedad.foto_principal.length != 0
                                                        ? <img src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""} />
                                                        : <img src="/images/web/bedloop-nofoto.png" alt="--" title="" />
                                                }
                                            </div>
                                            <div className="bh-cart__preu">
                                                <strong className="pricebase">{precioBase + " " + moneda}</strong>
                                            </div>
                                        </div>

                                        <div className="bh-cart__info">
                                            <h4>
                                                {
                                                    propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ?
                                                        propiedad.nombre_traducido[lang]
                                                        :
                                                        propiedad.nombre
                                                }
                                            </h4>
                                            <p className="bh-cart__subtitulo">
                                                <i className="fa-duotone fa-location-dot"></i> {propiedad.ciudad + ", " + propiedad.region}
                                            </p>
                                            {(nombretarifa || politica?.nombre?.[lang]) && (
                                                <p className="bh-cart__subtitulo">
                                                    {nombretarifa}
                                                    {politica?.nombre?.[lang] && (
                                                        <>
                                                            {" ("}
                                                            <button
                                                                type="button"
                                                                className="bh-cart__politica"
                                                                onClick={() => setModalPolitica({ nombre: politica.nombre?.[lang], descripcion: politica.descripcion?.[lang] })}
                                                            >
                                                                {politica.nombre[lang]}
                                                            </button>
                                                            {")"}
                                                        </>
                                                    )}
                                                </p>
                                            )}

                                            {llegada && salida && (
                                                <span className="bh-cart__badge">
                                                    <i className="fa-regular fa-calendar"></i>
                                                    {formatoFechaLlarga(llegada)} - {formatoFechaLlarga(salida)}
                                                </span>
                                            )}

                                            <div className="bh-cart__meta">
                                                <span><i className="fa-regular fa-moon"></i> {cuentaNoches} {t("Noches")}</span>
                                                <span><i className="fa-regular fa-user"></i> {adultos} {t("Adultos")}{ninos > 0 ? ", " + ninos + " " + t("Niños") : ""}{bebes > 0 ? ", " + bebes + " " + t("Bebés") : ""}</span>
                                            </div>
                                        </div>

                                        <div className="bh-cart__bottom">
                                            <button
                                                type="button"
                                                className={"bh-cart__details" + (detallesAbiertos ? " bh-cart__details--obert" : "")}
                                                onClick={() => setDetallesAbiertos(!detallesAbiertos)}
                                            >
                                                {t("Detalles")} <i className="fa-solid fa-chevron-down"></i>
                                            </button>

                                            {detallesAbiertos && (
                                                <div className="bh-cart__grid">
                                                    <div className="bh-cart__grid-item">
                                                        <span>{t("Tarifa")}</span>
                                                        <strong>{nombretarifa || "—"}</strong>
                                                    </div>
                                                    <div className="bh-cart__grid-item">
                                                        <span>{t("Cancelación")}</span>
                                                        {politica?.nombre?.[lang] ? (
                                                            <strong>
                                                                <button
                                                                    type="button"
                                                                    className="bh-cart__politica"
                                                                    onClick={() => setModalPolitica({ nombre: politica.nombre?.[lang], descripcion: politica.descripcion?.[lang] })}
                                                                >
                                                                    {politica.nombre[lang]}
                                                                </button>
                                                            </strong>
                                                        ) : (
                                                            <strong>—</strong>
                                                        )}
                                                    </div>
                                                    <div className="bh-cart__grid-item">
                                                        <span>{t("Habitaciones")}</span>
                                                        <strong>{propiedad.num_habitaciones ?? "—"}</strong>
                                                    </div>
                                                    <div className="bh-cart__grid-item">
                                                        <span>{t("Huéspedes")}</span>
                                                        <strong>{adultos} {t("Adultos")}</strong>
                                                    </div>
                                                    <div className="bh-cart__grid-item bh-cart__grid-item--extras">
                                                        <span>{t("Extras")}</span>
                                                        <div className="bh-cart__extras" data-extras-hab="0"></div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })()}
                        <div className="mt-3 mb-5 text-start">
                            <button className="btn btn-primary"
                                onClick={() => handleBack()}
                                style={{ background: "" + websgrupo.color_corporativo_web + "", border: "1px solid" + websgrupo.color_corporativo_web }}
                            >
                                {t("Cambiar fechas")}
                            </button>
                        </div>
                        {websgrupo.activa_multiunit === 1 && numpropiedades > 1
                            ?
                            <>
                                <h4>{t("Número de habitaciones")}</h4>
                                <div className="linia"></div>
                                <div className="mt-3 mb-3">
                                    <select className="mb-0 form-control extra" id="numpropiedades0" onChange={() => handleChangeNumPropiedades()} defaultValue="1" ref={numpropiedades0Ref}>
                                        {vectornumpropiedades}
                                    </select>
                                </div>

                            </>
                            :
                            null
                        }


                        <h4>{t("Resumen")}</h4>
                        <div className="linia"></div>

                        {(showHayExtraCat === "block" || nombreobligatorios !== "") &&
                            <>
                                <div className="mt-2 mb-2 linia"></div>
                                <div className="mb-3 row">
                                    <div className="col-12">{t("Servicios Adicionales")}</div>
                                </div>
                            </>
                        }


                        <div className="mb-3 row" id="hayextracat" style={{ display: showHayExtraCat }}>
                            <div className="col-8">{t("Tasas")}</div>
                            <div className="col-4 text-end"><span id="extracat" ref={pextracatRef}></span> {moneda}</div>
                        </div>

                        <div className="mb-3 row">
                            <div className="col-12 row" ref={losextrasRef}>{t(nombreobligatorios)}</div>
                            {/*<div className="col-8" id="nombresextras" ref={pextranombresRef}>{t(nombreobligatorios)}</div>*/}
                            <div className="col-12"></div>
                            <div className="col-4 text-end" style={{ display: "none" }}><span id="pextra" ref={pextraRef}>{(propiedad.fees / 100).toFixed(2)}</span> {moneda}</div>
                        </div>

                        <div className="mb-3 row muestra-codigo-carro" style={{ display: "none" }}>
                            <div className="col-8">{t("Código")}</div>
                            <div className="col-4 text-end"><span className="codigo-carro"></span> {moneda}</div>
                        </div>

                        <div className="mb-3 row">
                            <div className="col-8 fw-bolder">{t("Total")}</div>
                            <div className="col-4 text-end fw-bolder totalprice">{(parseFloat(precioBase) + parseFloat(propiedad.fees / 100)).toFixed(2)} {moneda} </div>
                        </div>


                        {mostrarPagar === 'block' &&
                            <div className="mt-3 mb-3 text-center row">
                                <button className="btn btn-primary"
                                    id="botonpago"
                                    disabled={enviando}
                                    onClick={() => handleSubmit()}
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {enviando ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            {t("Procesando")}...
                                        </>
                                    ) : (
                                        <>
                                            {prepagoRef > 0 ?
                                                <>
                                                    <i className="fa-duotone fa-credit-card"></i> <span id="titulopagar">{t("Pagar") + " " + t("Ahora")}</span> <span className="prepago">
                                                        {
                                                            tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0 && config.activa_transferencia === 1 && transferencia && prepagoRef === 0 ?
                                                                0
                                                                :
                                                                roundN(importePrepago, 2)
                                                            //((parseFloat(precioBase) + parseFloat(propiedad.fees / 100)) * parseFloat(precios[0].info_tarifa.politica.prepago / 100)).toFixed(2)
                                                        }
                                                    </span> <span id="pagarmoneda">{moneda}</span>
                                                </>
                                                :
                                                <>
                                                    <span id="titulopagar">{t("Confirmar")}</span> <span className="prepago"></span> <span id="pagarmoneda"></span>
                                                </>
                                            }
                                        </>
                                    )}
                                </button>
                            </div>
                        }

                        {
                            propiedad.deposito_reembolsable > 0 ?
                                <div className="mb-3 row">
                                    <div className="col-12 small">{t("La propiedad requiere un depósito de")} {parseFloat(propiedad.deposito_reembolsable).toFixed(2)} {moneda}. {t("Deberás abonarlo por anticipado o al momento de tu llegada al alojamiento.")}</div>
                                </div>
                                :
                                <></>
                        }

                        <p className="mt-4 mb-0">
                            <input type="checkbox" name="aceptacondiciones" required defaultChecked id="aceptacondiciones" ref={aceptacondicionesRef} />
                            <span className="small ms-2 text-start">
                                {t("Al reservar, acepta los")}<a href={"/" + preidioma + t("terminos")} target="_blank">  {t("términos y condiciones")}</a>, {t("así como la")} <a href={"/" + preidioma + t("politica-de-cancelacion")} target="_blank">{t("política de cancelación")}</a>. *
                            </span>
                        </p>
                        <p className="mt-4 mb-0">
                            <input type="checkbox" name="aceptacondiciones2" id="aceptacondiciones2" />
                            <span className="small ms-2 text-start">
                                {t("Acepto recibir información comercial, incluso por medios electrónicos")}.
                            </span>
                        </p>
                        <p className="mt-5 mb-0 small fst-italic text-end"> * {t("Impuestos incluidos")}</p>
                    </div>

                </div>

                {/*-- *************** DATOS RESERVA ****************** */}

                <span id="datosreserva" data-precioestancia0={precioBase} data-totalprice0={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-prepago0={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-resto0="0.00" data-extras0={propiedad.fees} data-tpcprepago="100" data-fees0="0" data-precioextratarifa="0"></span>
                <span id="datosreservaactuales" ref={datosreservaactualesRef} data-precioestancia={precioBase} data-totalprice={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-prepago={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-resto="0.00" data-extras={propiedad.fees} data-tpcprepago="100" data-fees="0" data-precioextratarifa="0"></span>

                {/*-- ************************************************ */}
            </div >
        </div >
    );
}

export default DatosReserva;
